import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { Flex } from 'rebass';
import { TopNavLink, Body1, Caption } from '../FontStyles';
import baseTheme from '../../themes/baseTheme';

const SubduedText = Styled(Caption)`
color: ${baseTheme.colors.primaryTextSubdued};
`;

const NavListItemWrapper = Styled(Flex)`
width: 100%;
height: auto;
color: ${baseTheme.colors.primaryFont};
background-color: #fff;
padding: ${props => (!props.secondary ? '16' : baseTheme.space[3])}px;
flex-direction: row;

${Body1}, ${SubduedText}{
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  text-align: left;
  text-decoration: none !important;
  text-decoration-style: none;
}



&:hover {
  color: ${baseTheme.colors.mediumPurple};
  border-color: ${baseTheme.colors.mediumPurple};
  box-shadow: none;
  background-color: ${baseTheme.colors.lightGrey}
  z-index: 1995;
}

&:focus {
  box-shadow: none;
}

&.active {
  color: #fff;
  border-color: ${baseTheme.colors.mediumPurple};
  background-color: ${baseTheme.colors.mediumPurple};
  box-shadow: none;
}

`;

const TopNavOuterWrapper = Styled(TopNavLink)`

width: 100%;

`;

class NotificationListItem extends React.PureComponent {
  render() {
    return (
      <TopNavOuterWrapper bg={this.props.unread ? baseTheme.colors.lightGrey : 'transparent'} to={this.props.to}>
        <NavListItemWrapper {...this.props} py={!this.props.secondary && '12'} className="NavListItemWrapper">
          <Flex flexWrap="wrap" pl={this.props.pl ? this.props.pl : 0} width={1}>
            <Flex justifyContent="space-between" width={1}>
              <Body1>{this.props.mainText ? this.props.mainText : this.props.children}</Body1>
              <Caption> Received on {this.props.timestamp} </Caption>
            </Flex>
            <Flex width={1}>
              <SubduedText css={{ marginBottom: '0' }} width={1}>
                {this.props.secondaryText}
              </SubduedText>
            </Flex>
          </Flex>
        </NavListItemWrapper>
      </TopNavOuterWrapper>
    );
  }
}

NotificationListItem.propTypes = {
  entry: PropTypes.object
};

NotificationListItem.defaultProps = {
  includeAvatar: true,
  external: false,
  entry: {
    fields: {
      quote: 'Quote Text Here',
      quotedPerson: 'Howard Look',
      quotedPersonTitle: 'Founder, Tidepool',
      navItemSecondaryText: '',
      pageLinked: {
        fields: {
          slug: ''
        }
      },
      avatarImage: {
        fields: {
          file: {
            url: ''
          }
        }
      }
    }
  }
};

/** @component */
export default NotificationListItem;
